import { Button, Modal } from "@material-ui/core";
import { Box } from "@mui/material";
import { Users } from "phosphor-react";
import { useContext, useState } from "react";
import { ArrowLeft, ChevronDown } from "react-feather";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { MovieColabContext } from "../../Context/MovieColabContext";
import ProfileDropdown from "../ProfileDropdown/ProfileDropdown.component";
import myTeamsPageStyles from "./MyTeamsPageStyles";

const ManageTeamHeader = ({ viewFrom }) => {
  const { loggedInUser } = useContext(MovieColabContext);

  const history = useHistory();
  const classes = myTeamsPageStyles();
  const [openModal, setModalOpen] = useState(false);
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") === null
      ? "dark"
      : localStorage.getItem("theme")
  );
  const toggleTheme = () => {
    // if the theme is not light, then set it to dark
    if (theme === "light") {
      localStorage.setItem("theme", "dark");
      setTheme("dark");
      // otherwise, it should be light
    } else {
      localStorage.setItem("theme", "light");
      setTheme("light");
    }
    window.location.reload();
  };
  return (
    <Box className={classes.header}>
      <Box className={classes.headerLeft}>
        <Button
          className={classes.backButton}
          startIcon={<ArrowLeft />}
          onClick={() => history.push("/")}
          style={{ width: "210px" }}
        >
          Back To Projects
        </Button>
        {viewFrom === "team-details" ? (
          <Button
            className={classes.backButton}
            startIcon={<Users />}
            onClick={() => history.push("/my-teams")}
            style={{ width: "210px" }}
          >
            My Teams
          </Button>
        ) : (
          ""
        )}
      </Box>
      <Box className={classes.headerLeft}>
        <Button
          className={classes.topBarIcon}
          onClick={() => setModalOpen(true)}
        >
          <div className={classes.userNameAvatar}>
            {loggedInUser?.first_name?.charAt(0).toUpperCase() ?? ""}
            {loggedInUser?.last_name?.charAt(0).toUpperCase() ?? ""}
          </div>
          <ChevronDown />
        </Button>
      </Box>
      <Modal
        open={openModal}
        onClose={() => setModalOpen(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <ProfileDropdown
          themeToggler={toggleTheme}
          // userInfo={props.userInfo}
        />
      </Modal>
    </Box>
  );
};

export default ManageTeamHeader;
